import { Card, Flex } from "@mantine/core";
import type { JSX } from "react";
import classes from "../PayDashboard.module.css";
import { formatUpdateTime } from "../utils";

interface UpdatedTimeProps {
    updatedTime?: string;
}

export function UpdatedTime({ updatedTime }: UpdatedTimeProps): JSX.Element {
    const updateTime = updatedTime ? formatUpdateTime(updatedTime) : " coming soon";

    return (
        <>
            <Flex pr="3xs" align="center">
                <Card p="0" w="8px" h="8px" className={classes.dot} radius="xl" />
            </Flex>
            {updatedTime !== "Live" && (updatedTime ? <strong>Last updated:</strong> : <strong>Next update:</strong>)}
            <Flex pl="3xs">{updateTime}</Flex>
        </>
    );
}
